import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'

const ListsModalLink = ({
    AdditionalClasses = "",
    Color = "",
    Size = "",
    LinkText,
    ToggleListsModal
}) => {

    return (
        <Button className={AdditionalClasses} color={Color} size={Size} onClick={() => ToggleListsModal(true)}>{LinkText}</Button>
    );
};

ListsModalLink.propType = {
    AdditionalClasses: PropTypes.string,
    Color: PropTypes.string,
    Size: PropTypes.string,
    LinkText: PropTypes.string.isRequired,
    ToggleListsModal: PropTypes.func.isRequired
};

export default ListsModalLink;
